import React from 'react'
import { toast } from 'sonner'
import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'
import { Input } from '#app/components/ui/input'
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '#app/components/ui/tooltip'
interface CopyButtonProps {
	textToCopy: string
	label?: string
}

export function CopyButton({
	textToCopy,
	label = 'Copy text',
}: CopyButtonProps) {
	const [isCopied, setIsCopied] = React.useState(false)
	const inputId = React.useId()

	const handleCopy = async () => {
		await navigator.clipboard.writeText(textToCopy)
		setIsCopied(true)
		toast.success('Copied!', {
			id: 'copy-button',
			description: 'The text has been copied to your clipboard.',
		})
		setTimeout(() => setIsCopied(false), 2000)
	}

	return (
		<div className="w-full">
			<div className="relative">
				<label htmlFor={inputId} className="sr-only">
					{label}
				</label>
				<Input
					id={inputId}
					type="text"
					value={textToCopy}
					className="text-muted-foreground cursor-default pr-12 select-none focus:ring-0 focus-visible:ring-0 focus-visible:ring-offset-0"
					readOnly
					tabIndex={-1}
				/>
				<TooltipProvider delayDuration={0}>
					<Tooltip>
						<TooltipTrigger asChild>
							<Button
								variant="ghost"
								size="icon"
								className="hover:bg-muted absolute top-1/2 right-2 h-8 w-8 -translate-y-1/2"
								onClick={handleCopy}
								tabIndex={-1}
							>
								{isCopied ? (
									<Icon name="check" className="h-3.5 w-3.5" />
								) : (
									<Icon name="copy" className="h-3.5 w-3.5" />
								)}
								<span className="sr-only">{isCopied ? 'Copied!' : 'Copy'}</span>
							</Button>
						</TooltipTrigger>
						<TooltipContent side="top">
							{isCopied ? 'Copied!' : 'Copy'}
						</TooltipContent>
					</Tooltip>
				</TooltipProvider>
			</div>
		</div>
	)
}
